import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip, Typography, Box, Grid, } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import TableChartIcon from '@mui/icons-material/TableChart';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import PreviewModal from './PreviewModal';
import axios from 'axios';
import { url } from '../../../../App';
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const MultiViewModal = ({ open, close, data, loanId, onDelete, dbKey, dbDocType, docName = "sample" }) => {
    const [loaderOpen, setLoaderOpen] = React.useState(false);
    const [singleModal, setSingleModal] = useState(false);
    const [base64Image, setBase64Image] = useState("");
    const [docType, setDocType] = useState("");
    const getFileIcon = (file) => {
        // console.log(file , "file ")
        const type = file[dbDocType]?.toLowerCase() || '';
        if (type.includes('pdf')) return (
            <PictureAsPdfIcon
                fontSize="large"
                color="error"
                onClick={() => handleModal(file)}
                style={{ cursor: 'pointer' }}
            />
        );
        if (type.includes('image') || ['jpg', 'jpeg', 'png'].some(ext => type.includes(ext))) {
            return (
                <ImageIcon
                    fontSize="large"
                    color="primary"
                    onClick={() => handleModal(file)}
                    style={{ cursor: 'pointer' }}
                />
            );
        }
        if (type.includes('excel') || type.includes('sheet') || type.includes('xlsx')) {
            return (
                <TableChartIcon
                    fontSize="large"
                    color="success"
                    onClick={() => handleModal(file)}
                    style={{ cursor: 'pointer' }}
                />
            );
        }
        return (
            <InsertDriveFileIcon
                fontSize="large"
                onClick={() => handleModal(file)}
                style={{ cursor: 'pointer' }}
            />
        );
    };

    const handleModal = (file) => {
        // console.log(file , "file under the view ")
        if (file[dbDocType] === "xlsx") {
            toast.error("Excel file can't be preview. Please Download.")
            return;
        }
        setSingleModal(true);
        handleViewImage(file[dbKey], file[dbDocType])
    }

    const handleViewImage = async (key, format) => {
        // console.log(key)
        // console.log(format)
        setLoaderOpen(true);
        try {
            const { data } = await axios.post(url + "/loan/view/document", {
                key: key,
                token: Cookies.get("Token"),
                email: Cookies.get("Email"),
            })
            if (data.auth) {
                setLoaderOpen(false);
                // console.log(data, "data of base64")
                setSingleModal(true)
                setBase64Image(data.base64);
                setDocType(format)
            }
            else {
                setLoaderOpen(false);
                toast.error(data.error)
            }
        } catch (error) {
            setLoaderOpen(false);
            console.log(error)
        }
    };

    const handleDownloadImage = async (key, format) => {
        setLoaderOpen(true);
        try {
            const { data } = await axios.post(url + "/loan/view/document", {
                key: key,
                token: Cookies.get("Token"),
                email: Cookies.get("Email"),
            });

            if (data.auth) {
                setLoaderOpen(false);
                // console.log(data, "data of base64");
                downloadFileHandler(format, data.base64);
            }
        } catch (error) {
            setLoaderOpen(false);
            console.log(error);
        }
    };

    const downloadFileHandler = (format, base64) => {
        let mimeType;
        if (format.toLowerCase() === "pdf") {
            mimeType = "application/pdf";
        } else {
            mimeType = `image/${format.toLowerCase()}`;
        }
        const linkSource = `data:${mimeType};base64,${base64}`;
        const downloadLink = document.createElement("a");
        const fileName = `${docName}.${format}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    const deleteDocument = async (file) => {
        setLoaderOpen(true);
        try {
          const result = await onDelete(file);
      
          if (result === true) {
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        } catch (error) {
          console.error("Error while deleting:", error);
        } finally {
          setLoaderOpen(false);
        }
      };
      
    const handleClosePreview = () => {
        setBase64Image("")
        setSingleModal(false);
    };
    return (
        <>
            <Dialog open={open} onClose={close} maxWidth="md" fullWidth>
                {/* <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    {<span>{docName} Documents</span>}
                    <IconButton onClick={close} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle> */}
                <DialogTitle>
                    <Box display="flex" justifyContent="center" alignItems="center" position="relative">
                        <Typography variant="h6" textAlign="center" width="100%">
                            {docName} Documents
                        </Typography>
                        <IconButton
                            onClick={close}
                            size="small"
                            sx={{ position: 'absolute', right: 0 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>

                <DialogContent dividers >
                    <Grid container spacing={3}>
                        {data.map((file, index) => (
                            <Grid item xs={6} sm={4} md={3} key={index}>
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                    borderRadius={2}
                                    p={2}
                                    sx={{ boxShadow: 1 }}
                                >
                                    {getFileIcon(file)}
                                    <Typography variant="body2" sx={{ mt: 1, textAlign: 'center' }}>
                                        {file.name}
                                    </Typography>
                                    <Box mt={1} display="flex" justifyContent="center" gap={1}>
                                        <Tooltip title="Download">
                                            <IconButton color="success">
                                                <DownloadIcon onClick={() => handleDownloadImage(file[dbKey], file[dbDocType])} />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Delete">
                                            <IconButton color="error">
                                                <DeleteIcon onClick={() => deleteDocument(file)} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                    {base64Image && <PreviewModal open={singleModal} onClose={handleClosePreview} fileSrc={base64Image} fileType={docType} />}
                    <ToastContainer />
                    <Backdrop
                        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={loaderOpen}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>

                </DialogContent>
            </Dialog>
        </>
    )
}

export default MultiViewModal